var _path, _path2, _circle, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSubscribeLeftItems(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 315,
    height: 106,
    viewBox: "0 0 315 106",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M106 0.000976562L-8.39233e-05 0.000976562L-8.39233e-05 16.001C-8.39233e-05 65.7067 40.2943 106.001 89.9999 106.001L106 106.001L106 0.000976562Z",
    fill: "#FFED29"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M106 106L106 -8.39233e-05H122C171.706 -8.39233e-05 212 40.2943 212 89.9999V106L106 106Z",
    fill: "#3A70F6"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 53,
    cy: 53,
    r: 53,
    transform: "matrix(0 1 1 0 208.661 0)",
    fill: "#5DCC97"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.6004 12C65.6415 12 71.2742 17.8339 71.2742 24.8746V33.7258H80.1254C87.1664 33.7258 93 39.5597 93 46.6004C93 53.6415 87.1661 59.2742 80.1254 59.2742H71.2742V68.1254C71.2742 75.1664 65.6415 81 58.6004 81C51.5594 81 45.7258 75.1661 45.7258 68.1254V59.2742H36.8746C29.8336 59.2742 24 53.6415 24 46.6004C24 39.5594 29.8339 33.7258 36.8746 33.7258H45.7258V24.8746C45.7258 17.8336 51.5597 12 58.6004 12Z",
    fill: "#F3DF00"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.6004 12C65.6415 12 71.2742 17.8339 71.2742 24.8746V33.7258H80.1254C87.1664 33.7258 93 39.5597 93 46.6004C93 53.6415 87.1661 59.2742 80.1254 59.2742H71.2742V68.1254C71.2742 75.1664 65.6415 81 58.6004 81C51.5594 81 45.7258 75.1661 45.7258 68.1254V59.2742H36.8746C29.8336 59.2742 24 53.6415 24 46.6004C24 39.5594 29.8339 33.7258 36.8746 33.7258H45.7258V24.8746C45.7258 17.8336 51.5597 12 58.6004 12Z",
    fill: "#F3DF00"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubscribeLeftItems);
export default __webpack_public_path__ + "static/media/subscribe-left-items.beccaeb8846cbae0efb997ae45bbee98.svg";
export { ForwardRef as ReactComponent };